import img from '../../../img/Fire.svg'
import img2 from '../../../img/Pizza.svg'
import img3 from '../../../img/Sushi.svg'
import img4 from '../../../img/Drink.svg'
import img5 from '../../../img/Snacks.svg'
import img6 from '../../../img/Combo.svg'
import img7 from '../../../img/Dessert.svg'
import img8 from '../../../img/Sauce.svg'

export const menuData = [
    {
        img: img,
        name: "Акции",
        href:"#menu"
    },
    {
        img: img2,
        name: "Пицца",
        href:"#pizza"

    },
    {
        img: img3,
        name: "Суши",
        href:"#sushi"

    },
    {
        img: img4,
        name: "Напитки",
        href:"#drink"
    },
    {
        img: img5,
        name: "Закуски",
        href:"#snack"
    },
    {
        img: img6,
        name: "Комбо",
        href:"#combo"
    },
    {
        img: img7,
        name: "Десерты",
        href:"#desert"
    },
    {
        img: img8,
        name: "Соусы",
        href:"#sous"
    },
]